import React, { useEffect, useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import formatAmount from "../../../../../helpers/formatAmount";
import { MODULE_API } from "../../../../../apis";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import BUDGET_API from "../../../../../apis/budget.api";
import DEATH_API from "../../../../../apis/death.api";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import moment from "moment";
import "./styles/monthlybudget.css";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useUpdateBudgetHook from "./hook/useUpdateBudgetHook";
import SlidersContainer from "./SliderComponent";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
import { NumberCardSkeleton } from "../../../../../newComponents/Skeletons/DebtSkeleton";
import { setUnsavedChanges } from "../../../../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";
import swal from "sweetalert";

export default function MonthlyBudget() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingBudget, setLoadingBudget] = useState(false);
  const [totalData, setTotalData] = useState({});
  const [formData, setFormData] = useState([]);
  const [fieldsformData, setFieldsFormData] = useState({});
  const [toUpdate, setToUpdate] = useState(false);
  const [fieldsData, setFieldsData] = useState({});
  const [fields, setFields] = useState({});
  const [divorceCategory, setDivorceCategory] = useState(null);
  const [budgetData, setBudgetData] = useState(null);

  const { updateBudget, updateLoading } = useUpdateBudgetHook();

  const getAllBudgets = async () => {
    try {
      setLoadingBudget(true);
      const date = moment();
      // const startDate = date.clone().subtract(12, "months").startOf("month").format("YYYY-MM-DD")
      const startDate = date.startOf("month").format("YYYY-MM-DD");
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      const data = await BUDGET_API.fetchAllBudget(startDate, endDate, "all");
      if (data && data.status === 200 && data.categorized) {
        // setBudgetData(data.categorized);
        const enhancedData =
          data.categorized &&
          data.categorized.map((item) => ({
            ...item,
            postDivorceBudget: item.postDivorceBudget || item.amount || 0,
          }));
        setBudgetData(enhancedData);
        const promises =
          data.categorized &&
          data.categorized.map((budget) => {
            const payload = {
              startDate,
              endDate,
              category: budget.categoryId, // Send categoryId for this budget
            };
            return BUDGET_API.getCalculatedBudgetTransactions(payload).then(
              (response) => ({
                budget,
                response,
              })
            );
          });

        const results = await Promise.all(promises);

        const structuredData = results.map(({ budget, response }) => {
          console.log("Structured Data:", response);

          const usedAmount = response.currentMonthTransactions.totalAmount || 0;
          const totalAmount = budget.divorceBudgetAmount || budget.amount || 0;
          const totalDivorceAmount = budget.postDivorceBudget || 0;
          const newMonthlyBudget = totalDivorceAmount
            ? totalDivorceAmount - totalAmount
            : 0;
          const leftAmount = totalAmount - usedAmount;
          return {
            categoryId: budget && budget.categoryId && budget.categoryId,
            categoryName:
              (budget.budgetCategory && budget.budgetCategory.categoryName) ||
              "",
            subCategoryId:
              (budget && budget.subCategoryId && budget.subCategoryId) || null,
            usedAmount,
            leftAmount,
            totalAmount,
            totalDivorceAmount,
            newMonthlyBudget,
          };
        });
        console.log("Structured Data:", structuredData);
        const totalUsedAmount =
          structuredData.reduce((total, data) => {
            return total + data.usedAmount;
          }, 0) / 12;
        const totalLeftAmount = structuredData.reduce((total, data) => {
          return total + data.leftAmount;
        }, 0);
        const totalAmount = structuredData.reduce((total, data) => {
          return total + data.totalAmount;
        }, 0);
        const totalAmountDivorce = structuredData.reduce((total, data) => {
          return total + data.totalDivorceAmount;
        }, 0);
        const totalAmountDivorceDiff = totalAmount - totalAmountDivorce;
        const totalNewBudget =
          structuredData.reduce((total, data) => {
            return total + data.newMonthlyBudget;
          }, 0) + totalUsedAmount;
        const totalDifference = totalUsedAmount - totalNewBudget;
        setTotalData({
          totalUsedAmount,
          totalLeftAmount,
          totalAmount,
          totalNewBudget,
          totalDifference,
          totalAmountDivorce,
          totalAmountDivorceDiff,
        });
      }

      setLoadingBudget(false);
    } catch (error) {
      console.log(error);
      setLoadingBudget(false);
    }
  };

  const handleSaveCategory = async () => {
    let payload = {
      categoryName: divorceCategory,
      divorceBudget: true,
    };

    try {
      setLoadingBudget(true);
      setLoading(true);
      let data = await DEATH_API.createCategory(payload);
      if (data && data.status === 200) {
        // swal("Success", data.message, "success");
        const budgetCreatePayload = {
          categoryName: divorceCategory,
          categoryId: data.data && data.data.id,
          subCategoryId: null,
          subCategory: null,
          amount: 0,
          divorceBudget: true,
        };
        let res = await DEATH_API.createBudget(budgetCreatePayload);
        if (res && res.status === 200) {
          swal("Success", res.message, "success");
          await getAllBudgets();
        }
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
      setLoadingBudget(false);
    } catch (error) {
      console.log(error);
      setLoadingBudget(false);
      setLoading(false);
    }
    setDivorceCategory(null);
  };

  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset("Monthly Budget", {
        clientModules: [fieldsformData],
      });
      const res = await fetchData();
      console.log("resssssss", res);

      if (res && res.records) {
        setFieldsData(res.records);
      }
      console.log("result", result);
      setLoading(false);
      setToUpdate(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const getAttributes = async (name) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchAttributes(name);
      if (res && res.attributes) {
        console.log("Monthly Budget Attributes", res.attributes);
        setFields(res.attributes);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: "Monthly Budget",
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setFieldsData(res.records[0]);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };

  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(fieldsformData.id, {
        ...fieldsformData,
      });
      const res = await fetchData(fieldsformData.module);
      if (res && res.records) {
        setFields(res.records);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllBudgets();
    getAttributes("Monthly Budget");
    fetchData();
  }, []);

  const resetBudgetData = async (data) => {
    await updateBudget(data);
    await getAllBudgets();
  };

  useEffect(() => {
    if (fieldsData && fieldsData.id) {
      setToUpdate(true);
    }
  }, [fieldsData]);

  // Display values from the fields data
  const averageMonthlyBudget =
    fieldsData && fieldsData["12-Month Average Monthly Budget"]
      ? fieldsData["12-Month Average Monthly Budget"] / 12
      : 0;

  const postDivorceBudget =
    fieldsData && fieldsData["Post-Divorce Budget"]
      ? fieldsData["Post-Divorce Budget"]
      : 0;

  const budgetDifference = averageMonthlyBudget - postDivorceBudget;

  console.log("buddddddddd", totalData);

  return (
    <>
      <div className="budget-container">
        <div className="budget-title-container">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              columnGap: "3px",
            }}
          >
            <h2 className="budget-title">Monthly Budget</h2>
            <ToolTipCreator name={"Divorce_Monthly_Budget"} />
          </div>
        </div>
        {/* <div className="budget-help-icon-container">
          <img src={helpIcon || "/placeholder.svg"} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      <div className="input-fields-container" style={{ position: "relative" }}>
        <DisabilityFormCreator
          data={fields}
          values={fieldsData}
          setSubmitBody={setFieldsFormData}
        />

        <NewLoader isLoading={loading || updateLoading} />
      </div>
      <div className="handle-submit-button-container">
        <button
          className="submit-button"
          onClick={() => {
            if (toUpdate) {
              updateRecord();
            } else {
              createAttributes();
            }
          }}
        >
          {toUpdate ? "Update" : "Submit"}
        </button>
      </div>
      <div
        className="stockLabel"
        style={{
          display: "flex",
          alignItems: "center",
          width: "fit-content",
          gap: "2px",
        }}
      >
        <label>Add Category</label>
        <ToolTipCreator name="Divorce_Add_Category" />
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="add-budget-field-conatiner">
          <input
            type="text"
            placeholder="Add Category"
            style={{
              outline: "none",
              border: "none",
              width: "98%",
            }}
            onChange={(e) => {
              setDivorceCategory(e.target.value);
            }}
            value={divorceCategory ? divorceCategory : ""}
          />
          <div
            className="upload add-budget-field-symbol"
            style={{
              opacity: divorceCategory && divorceCategory ? 1 : "0.3",
              cursor:
                divorceCategory && divorceCategory ? "pointer" : "not-allowed",
            }}
            onClick={() => {
              if (divorceCategory && divorceCategory) {
                handleSaveCategory();
              }
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "14px", height: "14px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="categories-container">
        <div className="categories-title-container">
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              columnGap: "3px",
            }}
          >
            <h2 className="categories-title">Categories</h2>
            <ToolTipCreator name={"Divorce_Categories"} />
          </div>
        </div>
        {/* <div className="categories-help-icon-container">
          <img src={helpIcon || "/placeholder.svg"} alt="help" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {/* <div className="categories-description-container">
        <p className="categories-description">Adjust Your Average Monthly Budget </p>
      </div> */}
      <div
        className="slider-component-container"
        style={{ position: "relative" }}
      >
        <SlidersContainer
          setFormData={setFormData}
          budgetData={budgetData && budgetData}
          resetBudgetData={resetBudgetData}
        />
        <NewLoader isLoading={loadingBudget} />
      </div>
      <div className="handle-submit-button-container">
        <button
          className="submit-button"
          onClick={async () => {
            await updateBudget(formData);
            await getAllBudgets();
            dispatch(setUnsavedChanges(false));
          }}
        >
          Update Budget
        </button>
        <div className="summary-section-container">
          <div className="summary-section">
            <div className="total-summary-section">
              <h2 className="total-summary">Total</h2>
            </div>
            <div className="average-budget-summary-section">
              <h2 className="average-budget-summary">Average Budget</h2>
            </div>
          </div>
          <div className="amount-spend-section">
            <div className="amount-spend-title-section">
              <h2 className="spend-amount-title">Avg. Monthly Spend</h2>
            </div>
            <div className="spend-amount-amount-section">
              <h2 className="spend-amount-amount">
                {updateLoading || loading || loadingBudget ? (
                  <NumberCardSkeleton />
                ) : totalData && totalData.totalAmount ? (
                  `$${formatAmount(totalData.totalAmount)}`
                ) : (
                  "$0.00"
                )}
              </h2>
            </div>
          </div>
          <div className="saved-amount-section">
            <div className="saved-amount-title-section">
              <h2 className="saved-amount-title">Post Divorce Budget</h2>
            </div>
            <div className="saved-amount-amount-section">
              <h2 className="saved-amount-amount">
                {updateLoading || loading || loadingBudget ? (
                  <NumberCardSkeleton />
                ) : totalData && totalData.totalAmountDivorce ? (
                  `$${formatAmount(totalData.totalAmountDivorce)}`
                ) : (
                  "$0.00"
                )}
              </h2>
            </div>
          </div>
          <div className="exceeded-amount-section">
            <div className="exceeded-amount-title-section">
              <h2 className="exceeded-amount-title">Difference</h2>
            </div>
            <div className="exceeded-amount-section">
              <h2 className="exceeded-amount-amount">
                {updateLoading || loading || loadingBudget ? (
                  <NumberCardSkeleton />
                ) : totalData && totalData.totalAmountDivorceDiff ? (
                  `$${formatAmount(totalData.totalAmountDivorceDiff)}`
                ) : (
                  "$0.00"
                )}
              </h2>
            </div>
          </div>
          {/*<NewLoader isLoading={updateLoading || loading} /> */}
        </div>
      </div>
    </>
  );
}
